module.exports = __webpack_public_path__ + "img/gr.3e987e73.png";